module.exports = __webpack_public_path__ + "img/yuyan.547d7b6b.svg";